/* ============================================================
   Avraham Shabat — theme.js
   Every block is guarded, so the same file is safe on every page,
   in both languages. Language comes from <html lang>.
   ============================================================ */
(() => {
  'use strict';
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const HE = (document.documentElement.lang || 'en') === 'he';
  const money = n => (HE ? '₪' : '$') + n.toLocaleString(HE ? 'he-IL' : 'en-US');
  const pieces = n => HE ? (n === 1 ? 'יצירה אחת' : n + ' יצירות')
                         : n + (n === 1 ? ' piece' : ' pieces');

  /* ── sticky offsets: --nav must equal the REAL header height ──
     The stylesheet default (112px) was tuned for an older, taller header;
     anything hardcoded drifts the moment the header changes, leaving a
     see-through gap above sticky toolbars. Measure instead. */
  const siteHead = $('.site-head');
  if (siteHead) {
    const setNav = () => document.documentElement.style.setProperty('--nav', siteHead.offsetHeight + 'px');
    setNav();
    addEventListener('resize', setNav);
    if ('ResizeObserver' in window) new ResizeObserver(setNav).observe(siteHead);
  }

  /* ── mobile nav ─────────────────────────────────────────── */
  const burger = $('.burger'), mobnav = $('#mobnav');
  if (burger && mobnav) burger.addEventListener('click', () => {
    const open = mobnav.classList.toggle('on');
    burger.setAttribute('aria-expanded', String(open));
  });

  /* ── reveal on scroll ───────────────────────────────────── */
  const rvs = $$('.rv');
  if (rvs.length) {
    if ('IntersectionObserver' in window && !reduce) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -10% 0px', threshold: .1 });
      rvs.forEach(el => io.observe(el));
    } else rvs.forEach(el => el.classList.add('in'));
  }

  /* ── bag counter (shared, sessionStorage) ───────────────── */
  const bagEls = $$('[data-bag-count]');
  const readBag = () => +(sessionStorage.getItem('as_bag') || 0);
  const paintBag = () => bagEls.forEach(e => e.textContent = readBag());
  const bumpBag = (n = 1) => { sessionStorage.setItem('as_bag', readBag() + n); paintBag(); };
  paintBag();

  /* ── toast ──────────────────────────────────────────────── */
  let toastT;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 2800);
  }

  /* ── add-to-bag buttons anywhere ────────────────────────── */
  $$('[data-add]').forEach(b => b.addEventListener('click', e => {
    e.preventDefault();
    if (b.disabled) return;
    bumpBag();
    toast(HE ? (b.dataset.add || '') + ' — נוסף לסל' : (b.dataset.add || 'Item') + ' added to bag');
  }));

  /* ── demo checkout: honest about what this build is ─────── */
  $$('[data-checkout]').forEach(b => b.addEventListener('click', e => {
    e.preventDefault();
    toast(b.dataset.checkout || (HE ? 'התשלום ייפתח ב־Shopify בהשקה' : 'Checkout opens on Shopify at launch'));
  }));

  /* ── pinned scroll scenes (home only) ───────────────────── */
  const actA = $('#actA'), actB = $('#actB');
  if ((actA || actB) && !reduce) {
    const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
    const seg = (p, a, b) => clamp((p - a) / (b - a), 0, 1);
    const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const bandF = (p, s) => ease(seg(p, s[0], s[1])) * (1 - ease(seg(p, s[2], s[3])));
    const A_SPANS = [[.20,.32,.46,.53], [.48,.60,.70,.77], [.72,.83,.93,.99]];
    const B_SPANS = [[.02,.16,.28,.38], [.34,.48,.60,.70], [.66,.80,.94,1]];
    const railFill = $('#rail i');
    const aHead = actA && $('.aHead', actA), aShot = actA && $('.shot', actA);
    const cs = actA ? $$('.callout', actA) : [];
    const ss = actB ? $$('.stmt', actB) : [];
    let M = { docH: 1, aTop: 0, aRange: 1, bTop: 0, bRange: 1 };

    const measure = () => {
      const vh = innerHeight;
      M = {
        docH: Math.max(document.documentElement.scrollHeight - vh, 1),
        aTop: actA ? actA.offsetTop : 0, aRange: actA ? Math.max(actA.offsetHeight - vh, 1) : 1,
        bTop: actB ? actB.offsetTop : 0, bRange: actB ? Math.max(actB.offsetHeight - vh, 1) : 1
      };
    };
    const render = y => {
      if (railFill) railFill.style.width = (clamp(y / M.docH, 0, 1) * 100) + '%';
      if (actA) {
        const pa = clamp((y - M.aTop) / M.aRange, 0, 1);
        if (aShot) aShot.style.setProperty('--figS', (.94 + ease(seg(pa, 0, .22)) * .06).toFixed(4));
        if (aHead) aHead.style.setProperty('--headO', bandF(pa, [.06,.20,.94,1]).toFixed(3));
        cs.forEach((el, i) => el.style.setProperty('--o', bandF(pa, A_SPANS[i]).toFixed(3)));
      }
      if (actB) {
        const pb = clamp((y - M.bTop) / M.bRange, 0, 1);
        ss.forEach((el, i) => el.style.setProperty('--o', bandF(pb, B_SPANS[i]).toFixed(3)));
      }
    };
    // damped scroll on an ON-DEMAND rAF loop — it stops once settled.
    // An always-on loop burns CPU and breaks the preview compositor.
    let cur = 0, running = false;
    const tick = () => {
      const t = scrollY;
      cur += (t - cur) * 0.12;
      if (Math.abs(t - cur) < 0.5) { cur = t; running = false; }
      render(cur);
      if (running) requestAnimationFrame(tick);
    };
    const kick = () => { if (!running) { running = true; requestAnimationFrame(tick); } };
    measure(); cur = scrollY; render(cur);
    addEventListener('scroll', kick, { passive: true });
    addEventListener('resize', () => { measure(); kick(); });
    addEventListener('load', () => { measure(); kick(); });
  }

  /* ── film: nothing downloads until asked ────────────────── */
  const playBtn = $('#playBtn');
  if (playBtn) playBtn.addEventListener('click', () => {
    const p = $('#player'), src = p.dataset.src, poster = p.dataset.poster;
    const v = document.createElement('video');
    v.setAttribute('controls', ''); v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'auto'); v.poster = poster;
    v.innerHTML = `<source src="${src}" type="video/mp4">`;
    // surface a failure instead of leaving a silent black box
    v.addEventListener('error', () => toast(HE ? 'הסרטון לא נטען — נסו לרענן' : 'The film failed to load — try refreshing'), true);
    p.replaceChildren(v);
    v.play().catch(() => {});   // user-gesture play; ignore autoplay-policy rejections
    v.focus();
  });

  /* ── PDP gallery ────────────────────────────────────────── */
  const stage = $('#stage');
  if (stage) {
    const thumbs = $$('.rail button');

    /* Shopify's image_tag emits a srcset. A browser picks its source from
       srcset and ignores src entirely, so setting .src alone changed
       nothing and every thumbnail appeared to open the same photo. Both
       have to be replaced. */
    const paint = (url, cap) => {
      stage.srcset = url;
      stage.src = url;
      const el = $('#cap'); if (el && cap) el.textContent = cap;
    };

    const show = i => {
      const b = thumbs[i]; if (!b) return;
      at = i;
      thumbs.forEach(x => x.setAttribute('aria-current', 'false'));
      b.setAttribute('aria-current', 'true');
      stage.style.opacity = 0;
      setTimeout(() => { paint(b.dataset.full, b.dataset.cap); stage.style.opacity = 1; }, 180);
    };
    thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));

    /* ── lightbox ─────────────────────────────────────────── */
    const shots = thumbs.length
      ? thumbs.map(b => ({ src: b.dataset.full, cap: b.dataset.cap || '' }))
      : [{ src: stage.currentSrc || stage.src, cap: stage.alt || '' }];
    let at = 0, box = null, lastFocus = null;

    const render = () => {
      const s = shots[at];
      $('img', box).src = s.src;
      $('img', box).srcset = s.src;
      $('img', box).alt = s.cap;
      const c = $('.lbcap', box); if (c) c.textContent = s.cap;
      const n = $('.lbnum', box); if (n) n.textContent = (at + 1) + ' / ' + shots.length;
    };
    const go = d => { at = (at + d + shots.length) % shots.length; render(); };

    const close = () => {
      if (!box) return;
      box.classList.remove('on');
      document.documentElement.style.overflow = '';
      setTimeout(() => { box.remove(); box = null; }, 200);
      if (lastFocus) lastFocus.focus();
    };

    const open = i => {
      at = i || 0;
      lastFocus = document.activeElement;
      box = document.createElement('div');
      box.className = 'lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      const many = shots.length > 1;
      box.innerHTML =
        '<button class="lbx" data-close aria-label="Close">&times;</button>' +
        (many ? '<button class="lbnav lbprev" data-prev aria-label="Previous image">&#8249;</button>' : '') +
        '<figure><img alt=""><figcaption class="lbcap"></figcaption></figure>' +
        (many ? '<button class="lbnav lbnext" data-next aria-label="Next image">&#8250;</button>' : '') +
        (many ? '<p class="lbnum"></p>' : '');
      document.body.appendChild(box);
      render();
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => box.classList.add('on'));
      $('[data-close]', box).focus();

      box.addEventListener('click', e => {
        if (e.target.closest('[data-close]')) return close();
        if (e.target.closest('[data-prev]')) return go(-1);
        if (e.target.closest('[data-next]')) return go(1);
        /* the backdrop is everything that is not the picture itself */
        if (!e.target.closest('figure')) close();
      });
    };

    const zoom = $('[data-zoom]');
    if (zoom) zoom.addEventListener('click', () => open(at));
    stage.addEventListener('click', () => open(at));
    stage.style.cursor = 'zoom-in';

    document.addEventListener('keydown', e => {
      if (!box) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    });
  }

  /* ── PDP price / options ────────────────────────────────── */
  const buyForm = $('#buyForm');
  if (buyForm) {
    /* This used to read a `data-base` attribute and radios named `klaf`,
       neither of which the section has emitted for a long time. `+undefined`
       is NaN, so every product's button read "ADD TO BAG — $NaN".

       The price now comes from the variant itself. If the data is missing or
       nothing matches, the server-rendered price is left exactly as it is —
       a wrong price is worse than a stale one, and NaN is worse than both. */
    const dataEl = $('[data-variants]', buyForm);
    let variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    const sel = $('select[name=id]', buyForm);
    const addBtn = $('#addBtn');

    const chosen = () => $$('fieldset input[type=radio]:checked', buyForm)
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(r => r.value);

    const match = () => {
      const want = chosen();
      if (!want.length) return null;
      return variants.find(v => v.opts.length === want.length
        && v.opts.every((o, i) => o === want[i])) || null;
    };

    const sync = () => {
      const v = match();
      if (!v) return;                       // leave whatever the server printed
      if (sel) sel.value = v.id;
      $$('#total, #stickyPrice').forEach(el => { el.textContent = v.priceText; });
      if (addBtn) {
        addBtn.disabled = !v.available;
        const label = $('#total', addBtn);
        if (!v.available && label) label.textContent = '';
      }
    };

    $$('fieldset input[type=radio]', buyForm).forEach(r =>
      r.addEventListener('change', sync));

    const giftOn = $('#giftOn'), giftBox = $('#giftBox'), giftMsg = $('#giftMsg');
    if (giftOn) giftOn.addEventListener('change', e => {
      giftBox.classList.toggle('on', e.target.checked);
      if (e.target.checked && giftMsg) giftMsg.focus();
    });
    if (giftMsg) giftMsg.addEventListener('input', e => {
      const n = $('#msgN'); if (n) n.textContent = e.target.value.length;
    });

    /* The cart drawer in commerce.js already confirms the add — it listens on
       document, so it still runs after this. No toast: two confirmations for
       one action is one too many, and this one used to announce $NaN. */
    const sa = $('#stickyAdd');
    if (sa) sa.addEventListener('click', () => buyForm.requestSubmit
      ? buyForm.requestSubmit() : buyForm.submit());

    sync();
  }

  /* ── wishlist ───────────────────────────────────────────── */
  $$('.wish').forEach(w => w.addEventListener('click', () => {
    const on = w.getAttribute('aria-pressed') === 'true';
    w.setAttribute('aria-pressed', String(!on));
    w.textContent = on ? '♡' : '♥';
  }));

  /* ── accordion ──────────────────────────────────────────── */
  $$('.q button').forEach(b => b.addEventListener('click', () => {
    const open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', String(!open));
    b.parentElement.querySelector('.a').classList.toggle('on', !open);
  }));

  /* ── sticky mobile buy bar ──────────────────────────────── */
  const bar = $('#sticky'), addBtn = $('#addBtn');
  if (bar && addBtn && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky');
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('on', show);
      bar.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0 }).observe(addBtn);
  }

  /* ── collection / search: filter + sort (client-side) ───── */
  const grid = $('#colGrid');
  if (grid) {
    const cards = $$('.pc', grid);
    const countEl = $('#colCount'), emptyEl = $('#colEmpty'), sortEl = $('#colSort'), qEl = $('#q');
    let active = new Set(), query = '';
    const apply = () => {
      let shown = 0;
      cards.forEach(c => {
        const tags = (c.dataset.motif || '').split(' ').filter(Boolean);
        const okTags = !active.size || [...active].every(a => tags.includes(a));
        const okQuery = !query || (c.dataset.search || '').includes(query);
        const ok = okTags && okQuery;
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = pieces(shown);
      if (emptyEl) emptyEl.style.display = shown ? 'none' : '';
      grid.style.display = shown ? '' : 'none';
    };
    $$('.chip').forEach(ch => ch.addEventListener('click', () => {
      const key = ch.dataset.filter;
      if (!key) { active.clear(); $$('.chip').forEach(x => x.setAttribute('aria-pressed', 'false')); ch.setAttribute('aria-pressed', 'true'); }
      else {
        const on = ch.getAttribute('aria-pressed') === 'true';
        ch.setAttribute('aria-pressed', String(!on));
        on ? active.delete(key) : active.add(key);
        const all = $('.chip[data-filter=""]'); if (all) all.setAttribute('aria-pressed', String(!active.size));
      }
      apply();
    }));
    if (sortEl) sortEl.addEventListener('change', () => {
      const v = sortEl.value;
      const sorted = cards.slice().sort((a, b) => {
        const pa = +a.dataset.price, pb = +b.dataset.price;
        if (v === 'price-asc') return pa - pb;
        if (v === 'price-desc') return pb - pa;
        if (v === 'name') return a.dataset.name.localeCompare(b.dataset.name, HE ? 'he' : 'en');
        return (+b.dataset.new || 0) - (+a.dataset.new || 0);
      });
      sorted.forEach(c => grid.appendChild(c));
    });
    if (qEl) qEl.addEventListener('input', () => { query = qEl.value.trim().toLowerCase(); apply(); });
    apply();
  }

  /* ── cart quantities ────────────────────────────────────── */
  const cart = $('#cart');
  if (cart) {
    const FREE = HE ? 1600 : 450, SHIP = HE ? 90 : 24;
    const recalc = () => {
      let sub = 0;
      $$('.line', cart).forEach(l => {
        const unit = +l.dataset.price, q = +$('.qn', l).textContent;
        const amt = unit * q;
        $('.amt', l).textContent = money(amt);
        sub += amt;
      });
      const ship = sub >= FREE || sub === 0 ? 0 : SHIP;
      $('#sub').textContent = money(sub);
      $('#ship').textContent = ship ? money(ship) : (HE ? 'חינם' : 'Free');
      $('#tot').textContent = money(sub + ship);
      $('#cartEmpty').style.display = $$('.line', cart).length ? 'none' : '';
    };
    cart.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      const line = b.closest('.line'); if (!line) return;
      if (b.classList.contains('rm')) { line.remove(); recalc(); return; }
      const n = $('.qn', line); if (!n) return;
      let q = +n.textContent;
      if (b.dataset.step === '+') q++;
      if (b.dataset.step === '-') q = Math.max(1, q - 1);
      n.textContent = q; recalc();
    });
    recalc();
  }

  /* ── contact / commission forms ─────────────────────────── */
  $$('form[data-demo]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    let ok = true;
    $$('[required]', f).forEach(inp => {
      const bad = !inp.value.trim() || (inp.type === 'email' && !/^\S+@\S+\.\S+$/.test(inp.value));
      inp.closest('.field').classList.toggle('err', bad);
      if (bad && ok) { inp.focus(); ok = false; }
    });
    if (!ok) return;
    f.style.display = 'none';
    const done = f.parentElement.querySelector('.sent');
    if (done) { done.classList.add('on'); done.setAttribute('tabindex', '-1'); done.focus(); }
  }));
})();

/* Country picker: submit on change, so there is no extra button to press.
   The <noscript> submit button in the markup covers JS being off. */
document.addEventListener('change', function (e) {
  var sel = e.target.closest && e.target.closest('[data-loc-select]');
  if (sel && sel.form) sel.form.submit();
});

/* ── Shabbat: count the closure down and lift it on time ──────────────── */
(function () {
  /* shabbat.js is fetched on demand, so the curtain may switch on after this
     file has already run. Start now if it is already up, otherwise wait. */
  if (!document.documentElement.classList.contains('is-shabbat')) {
    document.addEventListener('shabbat:on', start, { once: true });
    return;
  }
  start();

  function start() {
  var out = document.querySelector('[data-shabbat-ends]');
  var ends = window.__shabbatEnds;
  if (!out || !ends) return;

  var when = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Jerusalem', weekday: 'long', hour: '2-digit',
    minute: '2-digit', hour12: false
  }).format(new Date(ends));

  var clock = document.querySelector('[data-shabbat-clock]');
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  function tick() {
    var left = ends - Date.now();
    if (left <= 0) { location.reload(); return; }   // it is over; show the store
    out.textContent = when + ' Jerusalem';
    if (clock) {
      var h = Math.floor(left / 3600000);
      var m = Math.floor(left / 60000) % 60;
      var s = Math.floor(left / 1000) % 60;
      /* Hours are not padded — a leading zero on a number that only ever
         reaches 25 reads as a stopwatch rather than a wait. Minutes and
         seconds are, so the line never jitters. */
      clock.textContent = h + ':' + pad(m) + ':' + pad(s);
    }
  }
  tick();
  setInterval(tick, 1000);
  }
})();

/* ── Shabbat times table ──────────────────────────────────────────────── */
(function () {
  var t = document.querySelector('[data-shabbat-table]');
  if (!t || !window.Shabbat) return;
  var candle = +t.dataset.candle || 40, havdalah = +t.dataset.havdalah || 45;
  var S = window.Shabbat;
  var rows = S.upcoming(new Date(), +t.dataset.weeks || 12, candle, havdalah);
  var now = Date.now();
  var dm = { day: 'numeric', month: 'short' };
  t.querySelector('tbody').innerHTML = rows.map(function (w) {
    var live = now >= w.start.getTime() && now < w.end.getTime();
    /* One date span, then just the weekday and time in each column — the
       month does not need saying three times on one row. */
    var span = S.format(w.start, { day: 'numeric' }) + '\u2013' + S.format(w.end, dm);
    return '<tr' + (live ? ' class="now"' : '') + '>'
      + '<td>' + span + '</td>'
      + '<td>Fri ' + S.time(w.start) + '</td>'
      + '<td>Sat ' + S.time(w.end) + '</td>'
      + '</tr>';
  }).join('');
})();

/* ── form guard ───────────────────────────────────────────────────────────
   Shopify's hCaptcha runs on its server, so a plain script POSTing to
   /contact is already refused. What still gets through is a real browser
   driven by a bot — and a real browser runs this.

   Two tells, both of which a person cannot produce and a bot struggles to
   avoid: a field that is never shown, and a form filled faster than it can
   be read. Fails open on purpose; if any of this throws, the form submits
   as normal. A blocked customer costs more than a delivered spam. */
document.querySelectorAll('.fguard').forEach(function (guard) {
  var form = guard.closest('form');
  if (!form) return;
  var clock = form.querySelector('[data-form-clock]');
  var opened = Date.now();
  if (clock) clock.value = String(opened);

  form.addEventListener('submit', function (e) {
    try {
      var trap = guard.querySelector('input');
      var filled = trap && trap.value.trim() !== '';
      /* Read the opening time back off the field rather than a closure
         variable: it survives the form being re-rendered, and it is
         inspectable, which is the only way to prove this check works. */
      var t0 = parseInt(clock && clock.value, 10) || opened;
      /* Two and a half seconds. Nobody reads a label, types a message and
         submits inside that; a script does it in tens of milliseconds. */
      var tooFast = Date.now() - t0 < 2500;
      if (filled || tooFast) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    } catch (err) { /* never block a real customer over a script error */ }
  }, true);   /* capture, so it runs before anything that would send it */
});

